module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNLTMtMWgyMHYyMEgtM3oiLz48cGF0aCBkPSJNMCAxNC41di0xM0MwIDEgMSAwIDEuNSAwaDExdjEuNWgtMTF2MTNIMHptMTMuNS0xMmMuNSAwIDEgLjUgMSAxdjEzYzAgLjUtLjUgMS0xIDFoLTEwYy0uNSAwLTEtLjUtMS0xdi0xM2MwLS41LjUtMSAxLTFoMTB6TTEzIDRINHYxMmg5VjR6IiBmaWxsPSIjODQ5OUE1Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-copy-grey.svg
// module id = fSUn
// module chunks = 2